<template>
  <v-container fluid fill-height class="home-hero">
    <v-layout justify-center align-center column pa-5>
      <div
        class="font-weight-black blue--text text--darken-2 text-center"
        :class="{
          'display-1': $vuetify.breakpoint.xs,
          'display-2': $vuetify.breakpoint.sm,
          'display-3':
            $vuetify.breakpoint.md ||
            $vuetify.breakpoint.lg ||
            $vuetify.breakpoint.xl
        }"
      >
        ACCOUNTING
      </div>
      <div
        class="display-3 font-weight-black blue--text text--darken-2 text-center mb-3"
        :class="{
          'display-1': $vuetify.breakpoint.xs,
          'display-2': $vuetify.breakpoint.sm,
          'display-3':
            $vuetify.breakpoint.md ||
            $vuetify.breakpoint.lg ||
            $vuetify.breakpoint.xl
        }"
      >
        FOR YOUR BUSINESS
      </div>
      <div
        class="display-0 font-weight-bold blue--text text--darken-2 text-center"
      >
        Professional accounting services for your business regardless of size or
        industry
      </div>
      <v-btn fab class="mt-5 blue accent-4">
        <v-icon
          large
          color="white"
          v-scroll-to="{
            element: '#details-container',
            easing: 'ease-in-out',
            duration: 1000,
            offset: -50
          }"
        >
          expand_more
        </v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'HomeHero'
}
</script>

<style scoped>
.home-hero {
  background: url('../../assets/images/background.jpg');
  background-size: cover;
  width: 100%;
  height: 100%;
  max-height: 100vh;
}
.blue--text {
  text-shadow: 0 0 3px #ffd700; /* horizontal-offset vertical-offset 'blur' colour */
  -moz-text-shadow: 0 0 3px #ffd700;
  -webkit-text-shadow: 0 0 3px #ffd700;
}
</style>
